import ShoppingCartService from "basket/bascketBody/services/shopping-cart.service";
import { useErrorBoundary } from "basket/ErrorBoundary";
import { useEffect, useState } from "react";

export default function useInfoIcons(productType) {
    const handleError = useErrorBoundary();
    const [infoIcons, setInfoIcons] = useState([]);

    useEffect(() => {
        const fetchInfoIcons = async () => {
            try {
                const response = await ShoppingCartService.get('info-icons/' + productType);
                if (response) setInfoIcons(response);
            } catch (error) {
                handleError('Could not load item details. Please contact administrator');
            }
        };

        fetchInfoIcons();
    }, [productType]);

    return infoIcons;
}
